import clsx from 'clsx'
import React from 'react'

// A quiet neutral count beside a section title or page header.
export type CountChipProps = {
    value?: number
    loading?: boolean
    className?: string
}

export function CountChip({ value, loading, className }: CountChipProps) {
    if (loading && value === undefined) {
        return (
            <span
                aria-hidden
                className={clsx('inline-block h-5 w-6 animate-pulse rounded-full bg-fill-subtle', className)}
            />
        )
    }

    if (value === undefined) {
        return null
    }

    return (
        <span
            className={clsx(
                'rounded-full bg-fill-subtle px-2 py-0.5 text-xs font-medium text-ink-secondary',
                className
            )}
        >
            {value}
        </span>
    )
}
